import { render, staticRenderFns } from "./rmReportForms.vue?vue&type=template&id=2654fb38&scoped=true&"
import script from "./rmReportForms.vue?vue&type=script&lang=ts&"
export * from "./rmReportForms.vue?vue&type=script&lang=ts&"
import style0 from "./rmReportForms.vue?vue&type=style&index=0&id=2654fb38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2654fb38",
  null
  
)

export default component.exports